import { Breadcrumb } from '@totem/types/breadcrumb';
import { isNotNull } from '@totem/utilities/common';

export const getCalculatedBreadcrumb = (from: string) => {
  if (isNotNull(from)) {
    const components = from.split(':');

    if (components.length === 3) {
      const objectType = components[0];
      const objectID = components[1];
      const objectName = components[2];

      switch (objectType) {
        case 'device': {
          const breadcrumb: Breadcrumb = {
            label: objectName,
            link: `/dashboard/devices/${objectID}`,
          };

          return breadcrumb;
        }
        case 'catalog': {
          const breadcrumb: Breadcrumb = {
            label: 'Software Catalog',
            link: `/dashboard/software`,
          };

          return breadcrumb;
        }
        case 'role': {
          const breadcrumb: Breadcrumb = {
            label: objectName,
            link: `/dashboard/remoteAccess/auth0role/${objectID}`,
          };

          return breadcrumb;
        }
        case 'user': {
          const breadcrumb: Breadcrumb = {
            label: objectName,
            link: `/dashboard/remoteAccess/auth0user/${objectID}`,
          };

          return breadcrumb;
        }
        case 'building': {
          const breadcrumb: Breadcrumb = {
            label: objectName,
            link: `/dashboard/buildings/${objectID}`,
          };

          return breadcrumb;
        }
        case 'auth0roles': {
          const breadcrumb: Breadcrumb = {
            label: 'Auth0 Roles',
            link: `/dashboard/admin/auth0Roles`,
          };

          return breadcrumb;
        }
        case 'remoteAccessDashboard': {
          const breadcrumb: Breadcrumb = {
            label: objectName,
            link: `/dashboard/remoteAccessDashboard`,
          };

          return breadcrumb;
        }
        case 'buildingUserAudit': {
          const breadcrumb: Breadcrumb = {
            label: objectName,
            link: `/dashboard/remoteAccess/userAudit/${objectID}`,
          };

          return breadcrumb;
        }
        default:
          return null;
      }
    }
  }

  return null;
};
